import { render } from "./SaveSalaryComponent.vue?vue&type=template&id=9e13686c&scoped=true"
import script from "./SaveSalaryComponent.vue?vue&type=script&lang=js"
export * from "./SaveSalaryComponent.vue?vue&type=script&lang=js"

import "./SaveSalaryComponent.vue?vue&type=style&index=0&id=9e13686c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e13686c"]])

export default __exports__